<template>
  <form>
    <md-card>
      <md-card-header
        v-if="!everythingLoaded || requesting"
        class="md-card-header-icon md-card-header-green"
      >
        <div class="card-icon">
          <md-icon class="load-rotate">hourglass_empty</md-icon>
        </div>
        <h4 class="title">{{ title }}</h4>
      </md-card-header>
      <md-card-header v-else class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon>{{ formIcon }}</md-icon>
        </div>
        <h4 class="title">{{ title }}</h4>
      </md-card-header>

      <md-card-content>
        <h4 class="card-title">Basis gegevens</h4>
        <ValidationProvider
          name="label"
          rules="required|min:2"
          v-slot="{ passed, failed }"
        >
          <md-field
            :class="[
              { 'md-error': failed },
              { 'md-valid': passed },
              { 'md-form-group': true }
            ]"
          >
            <md-icon>face</md-icon>
            <label>Label</label>
            <md-input v-model="label" type="text"></md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <ValidationProvider
          name="description"
          rules="required|min:2"
          v-slot="{ passed, failed }"
        >
          <md-field
            :class="[
              { 'md-error': failed },
              { 'md-valid': passed },
              { 'md-form-group': true }
            ]"
          >
            <md-icon>face</md-icon>
            <label>Omschrijving</label>
            <md-input v-model="description" type="text"></md-input>

            <slide-y-down-transition>
              <md-icon class="error" v-show="failed">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="passed">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </ValidationProvider>

        <template>
          <h4 class="card-title">Rechten</h4>
          <template v-for="(permission, index) in allPermissionsBooleans">
            <md-switch :key="index" v-model="allPermissionsBooleans[index]">
              {{ allPermissions[index].label }}
            </md-switch>
          </template>

          <div class="form-category">* verplichte velden</div>
        </template>
      </md-card-content>

      <md-card-actions>
        <md-button
          :disabled="requesting"
          native-type="button"
          @click.native.prevent="goBack"
          v-bind:class="{
            'md-primary': !formTouched,
            'md-warning': formTouched
          }"
        >
          Terug
        </md-button>
        <md-button
          :disabled="!formTouched || requesting"
          native-type="submit"
          @click.native.prevent="validate"
          class="md-success"
        >
          Opslaan
        </md-button>
      </md-card-actions>
    </md-card>
  </form>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import Swal from "sweetalert2";

export default {
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      boolean: null,
      requesting: false,
      updateNameByLabel: true,
      name: "",
      guard_name: "",
      label: "",
      description: "",
      permission_ids: [],
      allPermissions: [],
      allPermissionsBooleans: [],
      touched: {
        label: false,
        description: false,
        allPermissionsBooleans: false
      },
      modelValidations: {
        label: {
          required: true,
          min: 2
        },
        description: {
          required: true,
          min: 2
        }
      },
      submitErrors: "",
      loaded: {
        user_role: false,
        permissions: false
      }
    };
  },
  methods: {
    init() {
      if (this.$route.params.id !== undefined) {
        this.updateNameByLabel = false;
        this.loadUserRole(this.$route.params.id);
      } else {
        this.name = "";
        this.guard_name = "api";
        this.label = "";
        this.description = "";
        this.permission_ids = [];

        this.loaded.user_role = true;

        setTimeout(this.resetTouched, 100);
      }
      this.loadUsersPermissions();
    },
    validate() {
      let permission_ids = [];

      permission_ids = [];
      for (var i in this.allPermissionsBooleans) {
        if (!this.allPermissionsBooleans[i]) {
          continue;
        }
        permission_ids.push(this.allPermissions[i].id);
      }

      this.requesting = true;
      this.$http
        .post(
          this.$apiBaseUrl +
            "user_roles/" +
            (this.$route.params.id !== undefined ? this.$route.params.id : ""),
          Object.assign({
            name: this.label,
            guard_name: this.guard_name,
            label: this.label,
            description: this.description,
            permission_ids: permission_ids
          })
        )
        .then(
          response => {
            this.password = "";
            this.confirmPassword = "";
            setTimeout(this.resetTouched, 100);
            this.notifyVue(
              "Gebruikersrol succesvol opgeslagen",
              "check",
              "success",
              5000
            );

            if (this.$route.params.id === undefined) {
              this.$router.go(-1);
            }
            this.requesting = false;
          },
          response => {
            if (response.status === 422) {
              let msg = "";

              this.submitErrors = response.data.errors;

              for (var i in response.data.errors) {
                for (var j in response.data.errors[i]) {
                  msg += "<br/>\n&bull;&nbsp;" + response.data.errors[i];
                }
              }

              this.notifyVue(msg, "add_alert", "danger", 0);
            } else {
              this.notifyVue(
                "Onbekende fout tijdens opslaan gebruikersrol",
                "report_problem",
                "danger",
                0
              );
            }
            this.requesting = false;
          }
        );
    },
    goBack() {
      if (!this.formTouched) {
        this.$router.go(-1);
        return;
      }

      this.showSwal();
    },
    loadUserRole(id) {
      this.requesting = true;
      this.$http.get(this.$apiBaseUrl + "user_roles/" + id).then(
        response => {
          this.name = response.data.user_role.name;
          this.guard_name = response.data.user_role.guard_name;
          this.label = response.data.user_role.label;
          this.description = response.data.user_role.description;
          this.permission_ids = response.data.user_role.permission_ids;
          this.connectPermissionsToButtons();

          setTimeout(this.resetTouched, 100);
          this.requesting = false;
          this.loaded.user_role = true;
        },
        response => {
          this.requesting = false;
          if (response.status === 403) {
            // this.notifyVue("U heeft geen rechten voor het beheren van gebruikersrollen", 'add_alert', 'danger', 0);
          }
        }
      );
    },
    loadUsersPermissions() {
      this.requesting = true;
      this.$http.get(this.$apiBaseUrl + "user_roles/permissions").then(
        response => {
          this.allPermissionsBooleans = [];
          this.allPermissions = this.sortCollection(
            response.data.user_permissions,
            "name",
            "asc"
          );

          this.connectPermissionsToButtons();

          this.requesting = false;
          setTimeout(this.resetTouched, 100);
          this.loaded.permissions = true;
        },
        response => {
          this.requesting = false;
          if (response.status === 403) {
            // this.notifyVue("U heeft geen rechten voor het beheren van gebruikersrollen", 'add_alert', 'danger', 0);
          }
        }
      );
    },
    connectPermissionsToButtons() {
      for (let i in this.allPermissions) {
        this.allPermissionsBooleans[i] = this.inArray(
          this.permission_ids,
          this.allPermissions[i].id
        );
      }
    },
    resetTouched() {
      this.touched.label = false;
      this.touched.description = false;
      this.touched.allPermissionsBooleans = false;
    },
    showSwal() {
      Swal.fire({
        title: "Waarschuwing!",
        text: "Weet u zeker dat u de wijzigingen wilt negeren?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Ja, ga terug zonder op te slaan",
        cancelButtonText: "Annuleren",
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$router.go(-1);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
        }
      });
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    },
    inArray(haystack, needle) {
      for (var i in haystack) {
        if (haystack[i] === needle) {
          return true;
        }
      }

      return false;
    },
    updateName() {
      if (this.updateNameByLabel === false || this.label === "") {
        return;
      }

      this.name = this.label
        .toLowerCase()
        .replaceAll(" ", "_")
        .replaceAll("-", "_")
        .substring(0, 64);
    }
  },
  watch: {
    label() {
      if (!this.requesting) {
        this.touched.label = true;
        this.updateName();
      }
    },
    description() {
      if (!this.requesting) {
        this.touched.description = true;
      }
    },
    allPermissionsBooleans() {
      if (!this.requesting) {
        this.touched.allPermissionsBooleans = true;
      }
    },
    $route(to, from) {
      this.init();
    }
  },
  computed: {
    title: function() {
      if (this.$route.params.id !== undefined) {
        return "Gebruikersrol bewerken";
      }
      return "Gebruikersrol toevoegen";
    },
    formIcon: function() {
      if (this.requesting) {
        return "hourglass_empty";
      }
      if (this.$route.params.id !== undefined) {
        return "person";
      }
      return "person_add";
    },
    formTouched: function() {
      for (var i in this.touched) {
        if (this.touched[i]) {
          return true;
        }
      }

      return false;
    },
    everythingLoaded: function() {
      for (let i in this.loaded) {
        if (!this.loaded[i]) {
          return false;
        }
      }

      return true;
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}
</style>
